import * as L from 'leaflet';

export function getScaleControlOptions(afterClick: () => void): L.PM.CustomControlOptions & { disableByOtherButtons: boolean } {
  return {
    name: 'scale',
    block: 'edit',
    title: 'Maßstab festlegen',
    afterClick,
    toggle: true,
    disableByOtherButtons: false
  };
}
